import { MusicStyleStatusEnum } from '../enums';

export interface MusicStyleInterface {
  id?: string;
  translationKey: string;
  musicStyleStatus: MusicStyleStatusEnum;
}
